export const API_URL_LOCAL = "http://localhost:1337/api";
export const API_URL_PROD = "/api";
export const API_URL =
  process.env.NODE_ENV === "production" ? API_URL_PROD : API_URL_LOCAL;

export const GOOGLE_SCRIPT_BUILD_ID =
  "AKfycbzqJjoryv2eAvwc-BqjDanNRxw6zw7YB0AD5cb4k3xzHvt85-7kx1WA0rT44xiQ-DHS";
  // "AKfycbwF1--F4FYr7ONS3fb7zHaxDs2PLpouf522DJxkYbk_LD2Dd479_2QI0qjGPNs-Mdzs";
  // "AKfycbywlDhawly08gLPKoPkSGgmV22SG53RRR7C5JiseeeBC57QIUAx-c-fymS4ZDJwpRgO";
  // "AKfycbyBl-cX-duxbdaq6o31UhBr1PLepK68R_nMh52JkxCb2A36eMojNsD3QGDSwRyH7Ga4";
  // "AKfycbyQYCAIiRtFeLDUGAH6u1OCX2PTcwpuN0qj38DhnaFkU-y8TlyvmKkPUq1r_2cFemaa";
  // "AKfycbyFgbT6TLAzMtTNXqTrNW29O1K1JaRcADKF2tsdSRGpkxs0YpmDiiucfo42wrvK69Li";
  // "AKfycbwHiho8H5iZu4MXk2Cz6eXSiI2-aAgpfVSF2b77WlIa5pmohySaHTDX81UzYfY_8yr3";
  // "AKfycbxKXbCbdQHfRMOICB78iJKton6tSUoYSzEmzcOCijkahWmrArlMBNWeCCSteUGyRDRz";

export const GOOGLE_SCRIPT_BUILD_URL = `https://script.google.com/macros/s/${GOOGLE_SCRIPT_BUILD_ID}/exec`;

export const GOOGLE_SCRIPT_URL = GOOGLE_SCRIPT_BUILD_URL;
